/**
 * Active デバイスカタログの Query Key Factory
 *
 * React Queryのキャッシュ管理に使用します。
 */
export const activeCatalogKey = {
  all: ['deviceCatalog', 'active'] as const,
  detail: (id: string) => [...activeCatalogKey.all, 'detail', id] as const,
  header: (id: string) => [...activeCatalogKey.all, 'header', id] as const
} as const;